import { PropsWithChildren } from 'react';

import styled from 'styled-components';

import { PolicyPrivacy } from './Policy.Privacy';
import { PolicyService } from './Policy.Service';

export const Policy = (props: PropsWithChildren<unknown>) => {
  const { children } = props;
  return <Article>{children}</Article>;
};

Policy.Service = PolicyService;
Policy.Privacy = PolicyPrivacy;

const Article = styled.article`
  padding: 1rem 1.25rem;
  background-color: white;

  h1,
  h2 {
    text-align: center;
  }

  h2 {
    margin-top: 3rem;
  }

  h3 {
    margin-top: 2rem;
  }
`;
